import firebase, { database } from "../firebase";
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import axios from "axios";

export function addNewProduct(prod) {
  return async (dispatch, getState) => {
    try {
      const user = getState().user.user;
      // Build payload
      const payload = {
        ...prod,
        ActionOn: new Date().toISOString(),
        ActionBy: user.Name,
        ActionByUID: user.UID,
        ActionByEmailID: user.EmailID,
        Action: constants.AUDIT_TRAIL_NEW,
        RegistrationID: user.RegistrationID,
      };

      const token = getState().user.uat;
      const response = await axios.post(
        constants.API_URL + "/catalog/products",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let key="";
      if(response.data.code=="0"){
      key=response.data.product.key;
      }
      else{
          throw new Error(response.data.message || "Failed to add product");
      }
      return response.data.product.key;
    } catch (error) {
      console.error("Error adding product:", error.response || error.message);
      throw error;
    }
  };
}

export function updateProduct(product, productId) {
  return async (dispatch, getState) => {
    try {
      const user = getState().user.user;
      // Build payload
      const payload = {
        ...product,
        ActionOn: new Date().toISOString(),
        ActionBy: user.Name,
        ActionByUID: user.UID,
        ActionByEmailID: user.EmailID,
        Action: constants.AUDIT_TRAIL_EDIT,
        RegistrationID: user.RegistrationID,
      };
      const token = getState().user.uat;
      const response = await axios.put(
        `${constants.API_URL}/catalog/products/${productId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating product:", error.response || error.message);
      throw error;
    }
  };
}


export function getInstockDetailSingleProduct(productId, locationId,from=1,size=100) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/inventory/instock/item-ledger?productID=${productId}&locationID=${locationId}&from=${from}&size=${size}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      return  response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getInstockProductApi(productId) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/inventory/instock/product?productId=${productId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      return  response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getProductAuditTrail  (key) {
    return async (dispatch, getState) => {
    try {
         const token = getState().user.uat;
              const BASE_URL = "https://backend-o3dyulj4pa-el.a.run.app/v2";
      const response = await axios.get(
        `${BASE_URL}/catalog/products/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
     
        return response.data;
    } catch (err) {
        console.error("Error in fetchAuditTrailApi:", err);
        throw err;
    }
      };
};
export function getProductIdSalesTransaction(
  from = 1,
  size = 10,
  productId,
  transactionTypeId,
  transactionNo
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      let apiUrl = "/transaction/sales/product";

      let queryParams = [
        `from=${from}`,
        `size=${size}`,
        "isDeleted=false",
      ];

      if (productId) {
        queryParams.push(`productId=${productId}`);
      }

      if (transactionTypeId) {
        queryParams.push(`transactionTypeId=${transactionTypeId}`);
      }

      if (transactionNo) {
        queryParams.push(`transactionNo=${transactionNo}`);
      }

      apiUrl += `?${queryParams.join("&")}`;

      const response = await axios.get(
        `${constants.API_URL}${apiUrl}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
export function getProductIdInventoryTransaction(
  from = 1,
  size = 10,
  productId,
  transactionTypeId,
  transactionNo
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      let apiUrl = "/transaction/inventory/product";

      let queryParams = [
        `from=${from}`,
        `size=${size}`,
        "isDeleted=false",
      ];

      if (productId) {
        queryParams.push(`productId=${productId}`);
      }

      if (transactionTypeId) {
        queryParams.push(`transactionTypeId=${transactionTypeId}`);
      }

      if (transactionNo) {
        queryParams.push(`transactionNo=${transactionNo}`);
      }

      apiUrl += `?${queryParams.join("&")}`;

      const response = await axios.get(
        `${constants.API_URL}${apiUrl}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
export function deleteProduct(key) {
  return async (dispatch, getState) => {
    const user = getState().user.user;
    const userPayload = {
      ActionBy: user.Name,
      ActionByUID: user.UID,
      ActionByEmailID: user.EmailID,
      Action: constants.AUDIT_TRAIL_DELETE,
    };

    try {
      if (constants.API_URL) {
        const token = getState().user.uat;
        await axios.delete(`${constants.API_URL}/catalog/products/${key}`, {
          data: user, // 👈 DELETE body
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
      return true;
    } catch (error) {
      console.error("Delete Product Category Error:", error);
      throw error.response.data || error;
    }
  };
}

export function getProductDetails(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/catalog/products/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const product = response.data.product;
      return product;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getProducts(
  from = 0,
  size = 10,
  status = "active",
  searchParam,
  productType,
  name,
  sku,
  barCode,
  category,
  subCategory,
  brand,
  storeID,
  psin,
  globalCatalogue,
  excludeChildProduct,
  storeSpecificPrices
) {


  return async (dispatch, getState) => {

    try {


     const token = getState().user.uat;

      let apiUrl = "/catalog/products";

      const params = {

        from: Number(from),

        size: Number(size),

        searchParam,

        productType,

        name,

        sku,

        barCode,

        category,

        subCategory,

        brand,

        storeID,

        psin,

        globalCatalogue,

        excludeChildProduct,
        storeSpecificPrices

      };

      let queryParams = [];

      Object.keys(params).forEach((key) => {

        if (

          params &&
          Object.prototype.hasOwnProperty.call(params, key) &&

          params[key] !== undefined &&
          params[key] !== null &&
          params[key] !== ""

        ) {

          queryParams.push(

            key +
            "=" +
            encodeURIComponent(params[key])

          );

        }

      });

      // status filter

      if (status === "active") {

        queryParams.push("isDeleted=false");

      }

      if (status === "inActive") {

        queryParams.push("isDeleted=true");

      }

      // build final url

      if (queryParams.length > 0) {

        apiUrl =
          apiUrl +
          "?" +
          queryParams.join("&");

      }

      console.log(
        "Fetching URL:",
        apiUrl
      );

      const response =
        await axios.get(

          constants.API_URL + apiUrl,

          {

            headers: {

              Authorization:
                "Bearer " + token

            }

          }

        );

      if (

        response &&
        response.hasOwnProperty("data")

      ) {

        return response.data;

      }

      return null;

    }

    catch (error) {

      console.error(
        "Error fetching product data:",
        error
      );

      if (

        error &&
        error.hasOwnProperty("response") &&

        error.response &&
        error.response.hasOwnProperty("data")

      ) {

        throw error.response.data;

      }

      throw error;

    }

  };

};


export const getProductsForExport = ({
  searchParam = null,
  from = 0,
  size = 10,
  productType,
  name,
  sku,
  barCode,
  category,
  subCategory,
  brand,
  status = "active",
  storeID,
  psin,
  globalCatalogue,
  excludeChildProduct = true,
  pitId = null,
  searchAfter = null,
  storeSpecificPrices
} = {}) => {

  return async (dispatch, getState) => {

    try {

      const token = getState().user.uat;

      let apiUrl = "/catalogexport";
      let queryParams = [];

      // status handling
      if (status === "active") {
        queryParams.push("isDeleted=false");
      }

      if (status === "inActive") {
        queryParams.push("isDeleted=true");
      }

      // pagination
      queryParams.push(`size=${encodeURIComponent(size)}`);
      queryParams.push(`from=${encodeURIComponent(from)}`);

      // optional params
      if (storeSpecificPrices !== undefined) {
        queryParams.push(`storeSpecificPrices=${encodeURIComponent(storeSpecificPrices)}`);
      }

      if (psin !== undefined && psin !== null) {
        queryParams.push(`psin=${encodeURIComponent(psin)}`);
      }

      if (pitId !== undefined && pitId !== null) {
        queryParams.push(`pitId=${encodeURIComponent(pitId)}`);
      }

      if (searchAfter !== undefined && searchAfter !== null) {
        queryParams.push(`searchAfter=${encodeURIComponent(searchAfter)}`);
      }

      if (globalCatalogue !== undefined && globalCatalogue !== null) {
        queryParams.push(`globalCatalogue=${encodeURIComponent(globalCatalogue)}`);
      }

      queryParams.push(
        `excludeChildProduct=${encodeURIComponent(excludeChildProduct)}`
      );

      if (searchParam !== undefined && searchParam !== null) {
        queryParams.push(`searchParam=${encodeURIComponent(searchParam)}`);
      }

      if (productType !== undefined && productType !== null) {
        queryParams.push(`productType=${encodeURIComponent(productType)}`);
      }

      if (name !== undefined && name !== null) {
        queryParams.push(`name=${encodeURIComponent(name)}`);
      }

      if (sku !== undefined && sku !== null) {
        queryParams.push(`sku=${encodeURIComponent(sku)}`);
      }

      if (barCode !== undefined && barCode !== null) {
        queryParams.push(`barCode=${encodeURIComponent(barCode)}`);
      }

      if (category !== undefined && category !== null) {
        queryParams.push(`category=${encodeURIComponent(category)}`);
      }

      if (subCategory !== undefined && subCategory !== null) {
        queryParams.push(`subCategory=${encodeURIComponent(subCategory)}`);
      }

      if (brand !== undefined && brand !== null) {
        queryParams.push(`brand=${encodeURIComponent(brand)}`);
      }

      if (
        storeID !== undefined &&
        storeID !== null &&
        storeID !== ""
      ) {
        queryParams.push(`storeID=${encodeURIComponent(storeID)}`);
      }

      apiUrl += `?${queryParams.join("&")}`;

      const response = await axios.get(
        constants.API_URL + apiUrl,
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      );

    
        return response.data;

    } catch (error) {

      console.error("Error fetching product data:", error);

      if (
        error &&
        error.hasOwnProperty("response") &&
        error.response &&
        error.response.hasOwnProperty("data")
      ) {
        throw error.response.data;
      }

      throw error;
    }

  };

};

// export function getProducts(
//   from,
//   size,
//   option,
//   searchText,
//   searchProductType = "",
//   searchCategory = "",
//   searchSubCategory = "",
//   searchBrand = "",
//   searchTags = "",
//   searchDescription = "",
//   searchHSNSAC = "",
//   forBOM = false
// ) {
//   return async (dispatch, getState) => {
//     try {
//       let query = {
//         filters: [],
//         pagination: {
//           from: from,
//           size: size,
//         },
//         sort: [
//           {
//             field: "ActionOn",
//             order: "desc",
//           },
//         ],
//         returnFields: [],
//       };
//       if (searchText && searchText.trim() !== "") {
//         query.filters.push({
//           field: "BarCode",
//           operator: "like",
//           clause: "should",
//           value: searchText,
//         });
//         query.filters.push({
//           field: "SKU",
//           operator: "like",
//           clause: "should",
//           value: searchText,
//         });
//         query.filters.push({
//           field: "Name",
//           operator: "like",
//           clause: "should",
//           value: searchText,
//         });
//       }
//       if (option && option !== "") {
//         query.filters.push({
//           field: "IsDeleted",
//           operator: "exact",
//           clause: "must",
//           value: option === "inactive" ? true : false,
//         });
//       }
//       if (searchProductType && searchProductType !== "") {
//         const words = searchProductType.split(",");
//         words.map((w) => {
//           query.filters.push({
//             field: "ProductType",
//             operator: "exact",
//             clause: "should",
//             value: w,
//           });
//         });
//       }

//       const token = getState().user.uat;
//       const response = await axios.post(
//         `${constants.API_URL}/catalog/products/search`,
//         query,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const products = response.data.products || [];
//       const total = response.data.pagination.totalCount || 0;

//       return {
//         totalItemsCount: total,
//         products: products,
//       };
//     } catch (error) {
//       console.error(
//         "Error fetching products:",
//         error.response || error.message
//       );
//       throw error;
//     }
//   };
// }

export function getActiveProducts(
  registrationID,
  storeID,
  from = 0,
  size = 200
) {
  return async (dispatch, getState) => {
    try {
      const params = {
        registrationId: registrationID,
        from,
        size,
        isDeleted: false,
      };
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/catalog/products`,
        {
          params,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // 🔹 API se direct products aa rahe hain (ES hits nahi)
      const apiProducts = response.data.products || [];
      const totalCount = response.data.totalCount || 0;
      const products = [];

      apiProducts.forEach((product) => {
        product.ActionOn = null;
        let checkForateSpecificPriceOptions = true;

        // 🔹 Variant product
        if (
          product.hasOwnProperty("ParentProductID") &&
          product.ParentProductID !== ""
        ) {
          checkForateSpecificPriceOptions = false;
        }

        // 🔹 AccessibleToSelectedStores logic
        if (
          product.hasOwnProperty("AccessibleToSelectedStores") &&
          product.AccessibleToSelectedStores &&
          checkForateSpecificPriceOptions
        ) {
          const storePrice = product.StoreSpecificPrices.filter(
            (f) => f.StoreID === storeID
          );

          if (storePrice.length > 0) {
            const sp = storePrice[0];

            Object.assign(product, {
              RetailPrice: sp.RetailPrice,
              SupplyPrice: sp.SupplyPrice,
              Markup: sp.Markup,
              DiscountAmount: sp.DiscountAmount || 0,
              DiscountPercentage: sp.DiscountPercentage || 0,
              MRP: sp.MRP,
              WalletTopUpSameAsRetailPrice:
                sp.WalletTopUpSameAsRetailPrice || false,
              WalletTopUpAmount: sp.WalletTopUpAmount || 0,
              EditWalletTopUpAmount: sp.EditWalletTopUpAmount || false,
              key: product.key,
            });
            products.push(product);
          }
          // 🔹 StoreSpecificPricing logic
        } else if (
          product.hasOwnProperty("StoreSpecificPricing") &&
          product.StoreSpecificPricing &&
          checkForateSpecificPriceOptions
        ) {
          const storePrice = product.StoreSpecificPrices.filter(
            (f) => f.StoreID === storeID
          );
          if (storePrice.length > 0) {
            const sp = storePrice[0];
            Object.assign(product, {
              RetailPrice: sp.RetailPrice,
              SupplyPrice: sp.SupplyPrice,
              Markup: sp.Markup,
              DiscountAmount: sp.DiscountAmount || 0,
              DiscountPercentage: sp.DiscountPercentage || 0,
              MRP: sp.MRP,
              WalletTopUpSameAsRetailPrice:
                sp.WalletTopUpSameAsRetailPrice || false,
              WalletTopUpAmount: sp.WalletTopUpAmount || 0,
              EditWalletTopUpAmount: sp.EditWalletTopUpAmount || false,
              key: product.key,
            });
            products.push(product);
          } else {
            products.push(product);
          }
        } else {
          products.push(product);
        }
      });

      return {
        totalItemsCount: totalCount,
        searchResult: products,
        from,
        size,
      };
    } catch (error) {
      console.error("getActiveProducts error", error);
      throw error;
    }
  };
}

export const checkIfSKUExists = (SKU, productID) => {
  return async (dispatch, getState) => {
    try {
      let query = {
        filters: [
          {
            field: "SKU",
            operator: "exact",
            clause: "must",
            value: SKU.trim(),
          },
          {
            field: "IsDeleted",
            operator: "exact",
            clause: "must",
            value: false,
          },
        ],
        pagination: {
          from: 0,
          size: 1000,
        },
        sort: [],
        returnFields: [],
      };
      const token = getState().user.uat;
      const response = await axios.post(
        `${constants.API_URL}/catalog/products/search`,
        query,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("checkIfSKUExists response", response);
      let skuExists = false;
      const products = response.data.products || [];
      if (productID && productID.trim() !== "") {
        if (products.filter((f) => f.key !== productID).length > 0) {
          skuExists = true;
        }
      } else if (products.length > 0) {
        skuExists = true;
      }
      console.log("skuExists", skuExists);
      return skuExists;
    } catch (error) {
      console.error("SKU check error:", error);
      throw error;
    }
  };
};

export function pushProductToRedux(product) {
  return (dispatch) => {
    dispatch({ type: actionTypes.PUSH_PRODUCT_TO_REDUX, product });
  };
}

export function pushProductsToRedux(products) {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_ACTIVE_PRODUCTS, products });
  };
}

export function getProductsByBarCode(RegistrationID, from, size, searchText) {
  // let searchParameters = {
  //   from: from,
  //   size: size,
  //   // track_total_hits: true,
  //   query: {
  //     bool: {
  //       must: [
  //         { match: { RegistrationID: RegistrationID } },
  //         { match: { IsDeleted: false } },
  //       ],
  //       should: [],
  //       minimum_should_match: 1,
  //     },
  //   },
  //   sort: [
  //     {
  //       ActionOn: {
  //         order: "desc",
  //       },
  //     },
  //   ],
  // };
  // searchParameters.query.bool.should.push({
  //   match_phrase: { SKU: searchText.trim() },
  // });
  // searchParameters.query.bool.should.push({
  //   match_phrase: { BarCode: searchText.trim() },
  // });

  return async (dispatch, getState) => {
    let query = {
      filters: [
        {
          field: "BarCode",
          operator: "like",
          clause: "should",
          value: searchText,
        },
        {
          field: "SKU",
          operator: "like",
          clause: "should",
          value: searchText,
        },
        {
          field: "IsDeleted",
          operator: "exact",
          clause: "must",
          value: false,
        },
      ],
      pagination: {
        from: from,
        size: size,
      },
      sort: [
        {
          field: "ActionOn",
          order: "desc",
        },
      ],
      returnFields: [],
    };
    const token = getState().user.uat;
    const response = await axios.post(
      `${constants.API_URL}/catalog/products/search`,
       query,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const products = response.data.products || [];
    return {
      totalItemsCount: products.length,
      searchResult: products,
    };
  };
}

export function getProductsBySKU(RegistrationID, sku) {
  // let searchParameters = {
  //   query: {
  //     bool: {
  //       must: [
  //         { match: { RegistrationID: RegistrationID } },
  //         { match: { IsDeleted: false } },
  //         { match_phrase: { SKU: sku.trim() } },
  //       ],
  //     },
  //   },
  // };

  // console.log("getProductsBySKU", JSON.stringify(searchParameters));
  return async (dispatch, getState) => {
    let query = {
      filters: [
        {
          field: "SKU",
          operator: "exact",
          clause: "must",
          value: sku.trim(),
        },
        {
          field: "IsDeleted",
          operator: "exact",
          clause: "must",
          value: false,
        },
      ],
      pagination: {
        from: 0,
        size: 100,
      },
      sort: [
        {
          field: "ActionOn",
          order: "desc",
        },
      ],
      returnFields: [],
    };

    
    const token = getState().user.uat;
    const response = await axios.post(
      `${constants.API_URL}/catalog/products/search`,
       query,
      {
       
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const products = response.data.products || [];
    return products;
  };
}

export function getProductsForInventorySearch(
  RegistrationID,
  searchText,
  excludeUniqueNo
) {
  return async (dispatch, getState) => {

    let filters = [
      {
        field: "RegistrationID",
        operator: "exact",
        clause: "must",
        value: RegistrationID,
      },
      {
        field: "IsDeleted",
        operator: "exact",
        clause: "must",
        value: false,
      },
      {
        field: "ProductType",
        operator: "exact",
        clause: "should",
        value: "goods for sale",
      },
      {
        field: "ProductType",
        operator: "exact",
        clause: "should",
        value: "goods not for sale",
      },
    ];

    // search filter
    if (searchText && searchText.trim() !== "") {
      const searchParam = searchText.trim().toLowerCase();

      filters.push({
        field: "Name",
        operator: "like",
        clause: "should2",
        value: searchParam,
      });

      filters.push({
        field: "SKU",
        operator: "like",
        clause: "should2",
        value: searchParam,
      });

      filters.push({
        field: "BarCode",
        operator: "like",
        clause: "should2",
        value: searchParam,
      });
    }



    let query = {
      filters,
      pagination: {
        from: 0,
        size: 1000,
      },
      sort: [
        {
          field: "Name",
          order: "asc",
        },
      ],
      returnFields: [],
    };

    const token = getState().user.uat;

    const response = await axios.post(
      `${constants.API_URL}/catalog/products/search`,
      query,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return {
      totalItemsCount: response.data.pagination.totalCount,
      searchResult: response.data.products,
    };
  };
}

export function poupulateSaleCategories() {
  return (dispatch, getState) => {
    let salesProductCategories = getState().config.ProductCategories.filter(
      (e) =>
        !e.IsDeleted &&
        getState().config.Products.filter(
          (f) => e.key === f.CategoryID && f.ProductTypeID !== 2
        ).length > 0
    );
 
    console.log("  getState().config.Products",  getState().config.Products.length,"salesProductCategories",salesProductCategories.length,salesProductCategories);
    dispatch({ type: actionTypes.GET_SALES_PRODUCTS, salesProductCategories });
  };
}

export function poupulateSaleSubCategories() {
  return (dispatch, getState) => {
    let salesProductSubCategories = getState().config.ProductSubCategories.filter(
      (e) =>
        !e.IsDeleted &&
        getState().config.Products.filter(
          (f) => e.key === f.SubCategoryID && f.ProductTypeID !== 2
        ).length > 0
    );
    dispatch({
      type: actionTypes.GET_SALES_SUB_PRODUCTS,
      salesProductSubCategories,
    });
  };
}

export function getProductsForPOSearch(
  storeID,
  skuArray,
  excludeUniqueNo
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/catalog/products/getProductsForPOSearch`,
        {
          params: {
            storeID,
            skuArray,
            excludeUniqueNo,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

       return {
        totalItemsCount: response.data.totalCount,
        searchResult: response.data.products,
      };
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

